import { useT } from "@transifex/react";
import { useState } from "react";
import CreateEditTextInputPopup from "../../../basic/popups/CreateEditTextInputPopup";
import { MAX_NAME_LENGTH } from "../../../constants/LimitConstants";

interface EditClassMemberPopupProps {
    isOpen: boolean;
    currentName: string;
    otherMemberNames: string[];
    onClose: () => void;
    onSubmit: (newName: string) => Promise<void>;
}

const EditClassMemberPopup = (props: EditClassMemberPopupProps) => {
    const t = useT();

    const t_title = t("Edit student", { _tags: "SchoolClasses, EditClassMemberPopup" });
    const t_label = t("Name", { _tags: "SchoolClasses, EditClassMemberPopup" });
    const t_save = t("Save", { _tags: "SchoolClasses, EditClassMemberPopup" });
    const t_alreadyExists = (name: string) =>
        t("{name} already exists.", { _tags: "SchoolClasses, EditClassMemberPopup", name });

    const [inputValue, setInputValue] = useState(props.currentName);

    const trimmedInput = inputValue.trim();
    const otherNamesLower = props.otherMemberNames.map((n) => n.toLowerCase());
    const isDuplicate = trimmedInput.length > 0 && otherNamesLower.includes(trimmedInput.toLowerCase());
    const isUnchanged = trimmedInput === props.currentName.trim();

    return (
        <CreateEditTextInputPopup
            isOpen={props.isOpen}
            onClose={props.onClose}
            title={t_title}
            label={t_label}
            initialValue={props.currentName}
            onInputChange={setInputValue}
            alertMessage={isDuplicate ? t_alreadyExists(trimmedInput) : ""}
            isDisabled={isUnchanged}
            maxLength={MAX_NAME_LENGTH}
            primaryButton={{
                text: t_save,
                onSubmit: props.onSubmit,
            }}
        />
    );
};

export default EditClassMemberPopup;
